import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs, useRequestData } from 'wsm-common-data';
import MenuLink from './MenuLink';
import NavIcon from './NavIcon';

const DropdownItem = ({ enabled, grandChildItems, label, target, url }) => {
	const { childListLinkClasses } = usePrefs();
	const { deviceType } = useRequestData();

	if (!enabled) return <></>;

	const buildChildListLinkClasses = () => {
		const classesToReturn = [childListLinkClasses];
		if (deviceType === 'MOBILE') {
			if (grandChildItems.length) {
				classesToReturn.push(
					'panel-heading-link accordion-faux heading-tier2'
				);
			} else {
				classesToReturn.push('nav-link tier3');
			}
		}
		if (deviceType !== 'MOBILE') {
			classesToReturn.push('child');
		}

		return classesToReturn.join(' ').trim();
	};

	const classes = buildChildListLinkClasses();
	const additionalAttrs = { 'data-navigation-id': 'default' };

	return (
		<MenuLink
			childListLinkClasses={classes}
			url={url}
			target={target}
			additionalAttrs={additionalAttrs}
		>
			<NavIcon label={label} />
		</MenuLink>
	);
};

DropdownItem.propTypes = {
	grandChildItems: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			url: PropTypes.string,
			target: PropTypes.string
		})
	).isRequired,
	url: PropTypes.string.isRequired,
	target: PropTypes.string.isRequired,
	enabled: PropTypes.bool.isRequired,
	label: PropTypes.string.isRequired
};

export default DropdownItem;
